import { useState, useEffect, useRef, RefObject } from "react";

interface StickyOptions {
  rootMargin?: string;
  threshold?: number | number[];
}

export function useSticky<T extends HTMLElement>(
  options?: StickyOptions
): [RefObject<T>, boolean] {
  const [isSticky, setIsSticky] = useState(false);
  const elementRef = useRef<T>(null);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      {
        rootMargin: options?.rootMargin ?? "0px",
        threshold: options?.threshold ?? 0,
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [options?.rootMargin, options?.threshold]);

  return [elementRef, isSticky];
}
